import { apiCall } from '../../utils/restclient'
import {
  GET_AVAILABILITY_LIST,
  GET_AVAILABILITY_LIST_ERROR,
  GET_AVAILABILITY_LIST_RESET_SUCCESS,
  GET_AVAILABILITY_LIST_SUCCESS,
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  GET_VISIT_TYPES_SORT_OPTIONS_COLLECTION,
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  GET_VISIT_TYPES_SORT_OPTIONS_COLLECTION_ERROR,
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  GET_VISIT_TYPES_SORT_OPTIONS_COLLECTION_SUCCESS,
} from './AvailabilityConstants'

export const getAvailabilitiesList = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  offset,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  count,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  fromDateTime,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  toDateTime,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  searchText,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  sortConditionArray,
  isSortReset = false,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  sortByStateCondition,
}) => {
  const encodedFromDate = encodeURIComponent(fromDateTime)
  const encodedToDate = encodeURIComponent(toDateTime)
  const conditionVisitTypeRow = sortConditionArray ? `&VisitTypeIds=${sortConditionArray.join('&VisitTypeIds=')}` : ''
  const stateQueryRow =
    sortByStateCondition !== 'All' ? `&LicenseStateCode=${sortByStateCondition?.slice(-2) || ''}` : ''
  const requestQuery = `?Offset=${offset}&Count=${count}&FromDateTime=${encodedFromDate}&ToDateTime=${encodedToDate}&SearchValue=${encodeURIComponent(
    searchText,
  ).replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16)}`)}${conditionVisitTypeRow}${stateQueryRow}`
  const endpoint = `api/v1/providers/scheduled${requestQuery}`
  const action = {
    type: GET_AVAILABILITY_LIST,
  }
  try {
    apiCall(
      endpoint,
      'GET',
      null,
      null,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      {
        success: isSortReset ? GET_AVAILABILITY_LIST_RESET_SUCCESS : GET_AVAILABILITY_LIST_SUCCESS,
        error: GET_AVAILABILITY_LIST_ERROR,
      },
      null,
      null,
      null,
      null,
      true,
    )
  } catch (e) {
    console.log(e)
  }
  return action
}
